import { ValidateStringInput } from "./validate-string-input.function";

interface ParsedContactInfo {
    email?: string;
    phone?: string;
}
/**
 * Compares case insensitive/Normalized Email-Email and Phone-Phone to find whether this is the same person/contact
 * For BuilderActor-DocumentActor
 * @returns True if both (email & Phone) match
 */
export function MatchContacts(aModelContainingEmailAndPhone1: any, aModelContainingEmailAndPhone2: any): boolean {

    const contact1 = toContactInfo(aModelContainingEmailAndPhone1);
    const contact2 = toContactInfo(aModelContainingEmailAndPhone2);

    if (!contact1 || !contact2) {
        return false;
    }

    let matchedEmails = CompareEmails(contact1.email, contact2.email);
    if (!matchedEmails) {
        return false;
    }
    let matchedPhone = ComparePhoneNumbers(contact1.phone, contact2.phone);
    return matchedPhone;
}



/**
 * Function to normalize and compare possible Emails for match
 * @param email1 a string ex:'Robbert@Test.Nl'
 * @param email2 a string ex: '|robbert@test.nl'
 * @returns whether the normalized (loweredcase) email (string) matches: == 
 */

export function CompareEmails(email1: any, email2: any): boolean {

    // must be strings
    if (!ValidateStringInput(email1)) {
        return false;
    }

    if (!ValidateStringInput(email2)) {
        return false;
    }

    const normalized1 = email1.toLowerCase().trim();
    const normalized2 = email2.toLowerCase().trim();

    return normalized1 === normalized2;
}




/**
 * Function to normalize and compare possible Phonenumbers for match
 * @param phoneNumber1 a string ex:'0612344321'
 * @param phoneNumber2 a string ex: '+31612344321'
 * @returns whether the normalized (06->+316) phonenumber (string) matches: == 
 */

export function ComparePhoneNumbers(phoneNumber1: any, phoneNumber2: any): boolean {

    // must be strings
    if (!ValidateStringInput(phoneNumber1)) {
        return false;
    }

    if (!ValidateStringInput(phoneNumber2)) {
        return false;
    }

    const normalizeNumber = (num: string): string => {
        // Remove spaces, dashes, parentheses
        let cleaned = num.replace(/[\s\-()]/g, "");

        // Convert 00 prefix to +
        if (cleaned.startsWith("00")) {
            cleaned = "+" + cleaned.substring(2);
        }

        // Convert Dutch local format 06xxxxxxx to +316xxxxxxx
        if (cleaned.startsWith("06")) {
            cleaned = "+31" + cleaned.substring(1);
        }

        // Ensure it starts with +
        if (!cleaned.startsWith("+") && cleaned.startsWith("31")) {
            cleaned = "+" + cleaned;
        }

        return cleaned.toLowerCase();
    };

    const normalized1 = normalizeNumber(phoneNumber1);
    const normalized2 = normalizeNumber(phoneNumber2);

    return normalized1 === normalized2;
}


function toContactInfo(model: any): ParsedContactInfo | null {

    if (!model) return null;

    if ('phoneNumber' in model && 'email' in model) {
        return {
            email: model.email,
            phone: model.phoneNumber
        };
    } if ('phonenumber' in model && 'email' in model) {
        return {
            email: model.email,
            phone: model.phonenumber
        };
    }

    if ('mobile' in model && 'email' in model) {
        return {
            email: model.email,
            phone: model.mobile
        };
    }

    if ('phone' in model && 'email' in model) {
        return {
            email: model.email,
            phone: model.phone
        };
    }
    // generic fallback
    if (model && (model.email || model.phone || model.mobile)) {
        return {
            email: model.email,
            phone: model.phone ?? model.mobile
        };
    }

    return null;
}